import { RouteRecordRaw } from 'vue-router';
import NoHeaderLayout from '@/components/layout/NoHeaderLayout.vue';

// Public (unauthenticated) routes for the Automations domain. Right
// now this is just the buyer-facing form page at
// /a/:pluginHandle. The optional slug accepts links already sent;
// the backend selects the active form or the buyer's submitted form.
// Auth-protected automation routes live in `plugins.ts` because
// they hang off the existing plugin dashboard.
const automacoesRoutes: Array<RouteRecordRaw> = [
  {
    path: '/a/:pluginHandle/:slug?',
    name: 'PublicDataFormPage',
    meta: {
      label: 'PublicDataFormPage',
      layout: NoHeaderLayout,
      accessWithSession: undefined,
      useTailwind: true,
    },
    component: () => import(/* webpackChunkName: "automacoes" */ '@/views/tailwind/automacoes/PublicDataFormView.vue'),
  },
];

export default automacoesRoutes;
